import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

interface FooterProps {
  onStartDiagnostic?: () => void;
  onOpenTerms?: () => void;
}

export function Footer({ onStartDiagnostic, onOpenTerms }: FooterProps) {
  return (
    <footer className="relative overflow-hidden">
      {/* CTA Section - Dark background */}
      <div className="py-24 px-4 sm:px-8 lg:px-16 bg-slate-900">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          <div className="space-y-4">
            <span className="text-primary text-sm font-medium uppercase tracking-widest">
              Comece Agora
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white">
              Pronto para descobrir o potencial da sua operação?
            </h2>
            <p className="text-lg text-slate-300 max-w-2xl mx-auto">
              Inicie agora o diagnóstico e tenha uma visão clara dos gargalos e próximos passos.
            </p>
          </div>
          <div className="pt-4 space-y-4">
            <Button
              size="lg"
              variant="outline"
              className="text-lg px-8 py-7 min-w-[280px] rounded-full group bg-white text-slate-900 border-white hover:bg-white/90"
              onClick={onStartDiagnostic}
            >
              Iniciar diagnóstico
              <ArrowRight className="w-5 h-5 ml-2 transition-transform group-hover:translate-x-1" />
            </Button>
            <p className="text-sm text-slate-400">Leva cerca de 5-10 minutos</p>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="py-8 px-4 sm:px-8 lg:px-16 border-t border-border bg-card/30">
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            Powered by{' '}
            <a
              href="https://bossabox.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-foreground hover:text-primary transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background rounded"
            >
              BossaBox
            </a>
          </p>
          <button
            onClick={onOpenTerms}
            className="text-sm text-muted-foreground hover:text-primary transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background rounded"
          >
            Termos de uso e política de privacidade (LGPD)
          </button>
        </div>
      </div>
    </footer>
  );
}
